import { Component, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_FORMFIELD } from '@progress/kendo-angular-inputs';
import { ErrorService } from '@unity/services/error.service';

@Component({
  selector: 'unity-error-wrapper',
  standalone: true,
  imports: [KENDO_FORMFIELD, ReactiveFormsModule],
  templateUrl: './error-wrapper.component.html',
  styleUrl: './error-wrapper.component.scss',
})
export class ErrorWrapperComponent {
  private readonly errorService = inject(ErrorService);

  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $displayName = input.required<string | null>({ alias: 'displayName' });

  protected keys(obj: unknown) {
    if (!obj) {
      return [];
    }
    return Object.keys(obj);
  }

  protected errorMessage(errorKey: string, errorContext: unknown) {
    return this.errorService.getErrorValidationMessage(this.$displayName(), errorKey, errorContext);
  }
}
